module.exports = __webpack_public_path__ + "img/persent.1a187b19.png";